// The service worker only caches the app shell so Roadrunner opens offline
// with a friendly message. It never caches API or Supabase responses.
export function registerServiceWorker() {
  if (import.meta.env.DEV || !('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Non-essential: the app works without it.
    });
  });
}
